/*
 * ॐ नमः शिवाय
 *
 * Copyright (c) 2025 Rudra Coresoft Technologies Private Limited
 *
 * This software is licensed under the VIJAYA 1.0 License.
 * See the LICENSE file for the full text.
 */

import React from 'react';
import OrgField from './OrgField';

/**
 * A single-line input.
 *
 * `onChange` hands back the VALUE, not the event. Every caller in this wizard
 * dispatches a reducer action with it, and a form full of
 * `onChange={(e) => dispatch({ value: e.target.value })}` is noise that hides
 * which field is being set.
 *
 * `showCount` adds the same live `length/maxLength` counter as `OrgTextArea`,
 * turning to the error colour over the cap. Opt-in, so a capped field that
 * does not want the counter (the event title) is unchanged.
 */
export default function OrgInput({
  label, value, onChange, required, error, help,
  type = 'text', placeholder, inputMode, min, max, step, autoComplete, maxLength,
  showCount = false,
}) {
  const length = (value || '').length;
  const over = maxLength != null && length > maxLength;

  return (
    <OrgField label={label} required={required} error={error} help={help}>
      {({ id, invalid, describedBy }) => (
        <>
          {showCount && maxLength != null && (
            <span className={`orgf-count${over ? ' over' : ''}`}>{length}/{maxLength}</span>
          )}
          <input
            id={id}
            className="orgf-input"
            type={type}
            value={value ?? ''}
            placeholder={placeholder}
            inputMode={inputMode}
            min={min}
            max={max}
            step={step}
            autoComplete={autoComplete}
            maxLength={maxLength}
            aria-invalid={invalid}
            aria-describedby={describedBy}
            onChange={(event) => onChange(event.target.value)}
          />
        </>
      )}
    </OrgField>
  );
}
